export const DAYS_OF_WEEK = [
  {
    key: 'sunday',
    label: 'Sun',
    ordinal: 1
  }, {
    key: 'monday',
    label: 'Mon',
    ordinal: 2
  }, {
    key: 'tuesday',
    label: 'Tue',
    ordinal: 3
  }, {
    key: 'wednesday',
    label: 'Wed',
    ordinal: 4
  }, {
    key: 'thursday',
    label: 'Thu',
    ordinal: 5
  }, {
    key: 'friday',
    label: 'Fri',
    ordinal: 6
  }, {
    key: 'saturday',
    label: 'Sat',
    ordinal: 7
  }
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/executionWindows/daysOfWeek.ts